module.exports = __webpack_public_path__ + "media/images/lb/033-d0f2e5f556e5b2e8fc5b016f4187977c.svg";